/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import dashboardSlice, { DASHBOARD_KEY_IN_STORE } from './slice';
import { dashboardSaga } from './sagas';

export class DashboardModule {
	getRootKeyInStore(): string {
		return DASHBOARD_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return dashboardSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return dashboardSaga;
	}
}

export const moduleInstance = new DashboardModule();
